
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <h3 className="text-3xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>Jean-Claude Bastos</h3>
            </div>
            <p className="text-gray-300 mb-6 max-w-md" style={{ fontFamily: '"Exo 2", sans-serif' }}>
              Jean-Claude Bastos - UK Electronic Music Producer creating high-energy tracks with cinematic edge.
            </p>
            <div className="flex space-x-4">
              <a href="https://soundcloud.com/dj-jean-claude-bastos" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer transform hover:scale-110">
                <i className="ri-soundcloud-line text-2xl"></i>
              </a>
              <a href="https://open.spotify.com/artist/7MWynFxiCsINwkfZHunLEU" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer transform hover:scale-110">
                <i className="ri-spotify-line text-2xl"></i>
              </a>
              <a href="https://music.apple.com/za/artist/dj-jean-claude-bastos/1828068550" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer transform hover:scale-110">
                <i className="ri-music-line text-2xl"></i>
              </a>
              <a href="https://www.iheart.com/artist/dj-jean-claude-bastos-47509177/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer transform hover:scale-110">
                <i className="ri-heart-line text-2xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-cyan-400" style={{ fontFamily: '"Rajdhani", sans-serif' }}>QUICK LINKS</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: '"Exo 2", sans-serif' }}>{t('navigation.home')}</a></li>
              <li><a href="/music" className="text-gray-300 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: '"Exo 2", sans-serif' }}>{t('navigation.music')}</a></li>
              <li><a href="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: '"Exo 2", sans-serif' }}>{t('navigation.about')}</a></li>
              <li><a href="/videos" className="text-gray-300 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: '"Exo 2", sans-serif' }}>{t('navigation.videos')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-cyan-400" style={{ fontFamily: '"Rajdhani", sans-serif' }}>CONTACT</h4>
            <ul className="space-y-2">
              <li><a href="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: '"Exo 2", sans-serif' }}>Get in Touch</a></li>
              <li><a href="https://www.jeanclaudebastosmusic.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: '"Exo 2", sans-serif' }}>Official Website</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0" style={{ fontFamily: '"Exo 2", sans-serif' }}>
              © 2024 Jean-Claude Bastos. {t('footer.rights')}
            </p>
            <div className="flex items-center space-x-2">
              <span className="text-gray-400 text-sm" style={{ fontFamily: '"Exo 2", sans-serif' }}>{t('footer.made_with')}</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-cyan-400 hover:text-cyan-300 text-sm font-semibold transition-colors cursor-pointer"
                style={{ fontFamily: '"Exo 2", sans-serif' }}
              >
                Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
